import React from "react";

// Badge
export const Badge = ({ children, variant = "default", className = "" }) => {
  const variants = {
    default: "bg-brand-cream text-brand-charcoal",
    primary: "bg-brand-charcoal text-brand-cream",
    success: "bg-brand-charcoal text-brand-cream",
    warning: "bg-brand-cream text-brand-muted",
    danger: "bg-red-100 text-red-800",
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-lg text-xs font-medium ${variants[variant]} ${className}`}
    >
      {children}
    </span>
  );
};

export default Badge;
